import { format, parseISO } from 'date-fns'

function restoredDate(date: Date): Date {
  // Encrypted Inertia history is JSON-backed, so a browser back/forward restore
  // can rehydrate an already-parsed Date as its ISO string.
  return date instanceof Date ? date : parseISO(date as unknown as string)
}

export function parseCalendarDate(value: string): Date {
  return parseISO(value)
}

export function formatCalendarDate(date: Date): string {
  return format(restoredDate(date), 'yyyy-MM-dd')
}

export function formatHumanDate(args: { date: Date, excludeYear?: boolean}): string {
  return format(restoredDate(args.date), `EEEE d MMMM${args.excludeYear ? '' : ' yyyy'}`)
}

export function formatShortDate(date: Date): string {
  return format(restoredDate(date), 'dd MMM yyyy')
}
